/* eslint-disable @typescript-eslint/no-explicit-any */
/* typescript-eslint-disable no-implicit-any */

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type State = {
  translations: any;
  loading: boolean;
};

type Actions = {
  addTranslations: (translations: any) => void;
  clearTranslations: () => void;
  loadingTranslations: (loading: boolean) => void;
};

export const useTranslationStore = create(
  immer<State & Actions>((set) => ({
    translations: {},
    loading: false,
    addTranslations: (translations: any) => set(() => ({ translations })),
    clearTranslations: () => set({ translations: {} }),
    loadingTranslations: (loading: boolean) => set({ loading }),
  })),
);
